export default {
   API: process.env.REACT_APP_API,
   //GraphApi: "https://kanhacrm.xyz:4002/graphql" //staging URL
   GraphApi:"https://kanhacrm.xyz:4001/graphql" //Live URL
}